import messages from './tag-messages.js';
export default [
    {tag: '植物与僵尸', intlLabel: messages.plant_and_zombie},
    {tag: '三国演义', intlLabel: messages.three_kingdoms},
    {tag: '魔法相框', intlLabel: messages.magic_frame},
    {tag: '小斗士', intlLabel: messages.fighter},
    {tag: '愤怒的小鸟', intlLabel: messages.angry_bird},
    {tag: '皇家守卫军', intlLabel: messages.guard_army},
    {tag: '春节', intlLabel: messages.spring},
    {tag: '圣诞节', intlLabel: messages.christmas},
    {tag: '元旦', intlLabel: messages.new_year},
    {tag: '教师节', intlLabel: messages.teachers_day},
    {tag: '中秋节', intlLabel: messages.mid_autumn_day}
];
